import {
  newParticipantHandler,
  newParticipantErrorHandler,
  removeParticipantHandler,
  remailParticipantHandler,
  editParticipantDetailsHandler,
} from "./participants";
import { cancelPartyHandler, startDrawHandler } from "./parties";
import {
  showRelationshipForm,
  destroyRelationshipDataHandler,
  destroyRelationshipHandler,
  createRelationshipHandler,
  createRelationshipErrorHandler,
  relationshipSelectPartnerHandler,
} from "./relationships";
import { destroyUserHandler } from "./users";
import { showFlashMessages, registerRequestErrorHandler } from "./utils";
import { suggestEmailCorrectionsHandler } from "./mailcheck";

let scheduled = false;
let initialized = false;

export default function registerEventHandlers() {
  if (scheduled || initialized) return;
  const initialize = () => {
    if (initialized) return;
    initialized = true;
    newParticipantHandler();
    registerRequestErrorHandler();
    newParticipantErrorHandler();
    removeParticipantHandler();
    remailParticipantHandler();
    editParticipantDetailsHandler();

    cancelPartyHandler();
    startDrawHandler();

    showRelationshipForm();
    destroyRelationshipDataHandler();
    destroyRelationshipHandler();
    createRelationshipHandler();
    createRelationshipErrorHandler();
    relationshipSelectPartnerHandler();

    destroyUserHandler();

    showFlashMessages();
    suggestEmailCorrectionsHandler();
  };
  if (document.readyState === "loading") {
    scheduled = true;
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
}
